import { render } from "./SymptomList.vue?vue&type=template&id=00087105"
import script from "./SymptomList.vue?vue&type=script&lang=js"
export * from "./SymptomList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__